import { MESSAGES } from '../CommonConstants';

export class HttpError extends Error {
  public response: Response;

  constructor(response: Response) {
    super(MESSAGES.GENERIC_ERROR);

    this.response = response;
  }
}
